import { Input, InputGroup, InputLeftElement } from '@chakra-ui/react';
import { ChangeEventHandler } from 'react';
import { TableInstance } from 'react-table';
import { SearchIcon } from '~components/ui/icons';
import { CustomersTableCustomerFragment } from './__generated__/CustomersTable.graphql';
import { Columns } from './types';

type Props = {
  table: TableInstance<CustomersTableCustomerFragment>;
};

export function CustomerTableFilter({ table }: Props) {
  const handleCustomerSearch: ChangeEventHandler<HTMLInputElement> = (event) => {
    table.setFilter(Columns.Name, event.target.value ?? '');
  };

  return (
    <InputGroup width="full">
      <InputLeftElement pointerEvents="none" height="full">
        <SearchIcon color="gray.500" />
      </InputLeftElement>
      <Input
        type="search"
        placeholder="Search customers"
        onChange={handleCustomerSearch}
        height="12"
      />
    </InputGroup>
  );
}
